import { reduxStoreConfig } from "../../site/configuration/reduxStoreConfig";
import { useReduxState } from "../redux/hooks";
import { UserInfo } from "../types";

export const useUserInfo: () => [
  userInfo: UserInfo,
  setUserInfo: (userInfo: UserInfo) => void
] = () => {
  const [userInfo, setUserInfo] = useReduxState<UserInfo>(
    reduxStoreConfig.systemUserInfo
  );
  return [userInfo, setUserInfo];
};


